import { inject, Injectable } from "@angular/core";
import { StockApi } from "../Api/StockApi";
import { StockDetailState } from "./StockDetailState";
import { getBackendErrorMessage } from "../../../Common/Utility/UtilityError";

@Injectable()
export class StockDetailEffects {
  private readonly stockApi = inject(StockApi);
  private readonly stockDetailState = inject(StockDetailState);

  async loadStock(id: string): Promise<void> {
    this.stockDetailState.setStockLoading(true);
    this.stockDetailState.setStockError(null);

    try {
      const response = await this.stockApi.getStockById(id);
      this.stockDetailState.setStock(response);
      if (!response) {
        this.stockDetailState.setStockError("Stock record was not found.");
      }
    } catch (exception: unknown) {
      const message = getBackendErrorMessage(exception, "Unable to load stock details.");
      this.stockDetailState.setStockError(message);
    }
  }

  async loadMovements(stockId: string, page = 1, limit = 20): Promise<void> {
    this.stockDetailState.setMovementLoading(true);
    this.stockDetailState.setMovementError(null);

    try {
      const response = await this.stockApi.getStockMovements(stockId, page, limit);
      this.stockDetailState.setMovements(response.data, response.pagination);
    } catch (exception: unknown) {
      const message = getBackendErrorMessage(exception, "Unable to load stock movements.");
      this.stockDetailState.setMovementError(message);
    }
  }
}
